module.exports = __webpack_public_path__ + "files/1f668e37ef96cd29ceb6c8f753067cf3.png";


//////////////////
// WEBPACK FOOTER
// ./images/emoji-sheets/animals_nature-3.png
// module id = 508
// module chunks = 76